import { useQuery, useMutation } from "@tanstack/react-query";
import toast from 'react-hot-toast';
import { getToken,postSendPin, postValidatePin, loginUsuario, register,
getOneClickUsuario, AddOneClickUsuario, delOneClickUsuario,
sendLinkRecoveryPassword, restablecerPass, validarTokenRecuperacion, loginGoogle,loginApple,UpdateCredencial, getOldPasswordByUserId,
updatePassword, getOneClickCards, refrescarSesion
} from "../api";



export const useCheckToken = () => {
  const query = useQuery(
    ['token'],
    async () => getToken(),
    {
      staleTime: 1000 * 60 * 40, // 40 Minutos
      cacheTime: 1000 * 60 * 45, // 45 Minutos
      refetchInterval: 1000 * 60 * 35, // Renovar cada 35 minutos (antes de expirar)
      refetchIntervalInBackground: true, // Renovar incluso en segundo plano
      refetchOnWindowFocus: true, // Renovar cuando se vuelve a la ventana
      retry: false,
    },
  );

  return query;
};

export const useSendPin = () => {
  const query = useMutation({
    mutationKey: ['useSendPin'],
    mutationFn: postSendPin,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useValidatePin = () => {
  const query = useMutation({
    mutationKey: ['useValidatePin'],
    mutationFn: postValidatePin,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

// CA-15: password en texto plano contra /apiV2/usuario/loginUsuario (bcrypt
// server-side). Reemplaza al useLogin viejo (endpoint /apiV2/usuario/login,
// passwordless — retirado, CA-21).
export const useLoginUsuario = () => {
  const query = useMutation({
    mutationKey: ['useLoginUsuario'],
    mutationFn: loginUsuario,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useRegister = () => {
  const query = useMutation({
    mutationKey: ['useRegister'],
    mutationFn: register,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useGetOneClickUser = () => {
  const query = useMutation({
    mutationKey: ['useGetOneClickUser'],
    mutationFn: getOneClickUsuario,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useGetOneClickCards = () => {
  const query = useMutation({
    mutationKey: ['useGetOneClickCard'],
    mutationFn: getOneClickCards,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useAddOneClickUser = () => {
  const query = useMutation({
    mutationKey: ['useAddOneClickUser'],
    mutationFn: AddOneClickUsuario,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useDelOneClickUser = () => {
  const query = useMutation({
    mutationKey: ['useDelOneClickUser'],
    mutationFn: delOneClickUsuario,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useSendLinkRecoveryPass = () => {
  const query = useMutation({
    mutationKey: ['useSendLinkRecoveryPass'],
    mutationFn: sendLinkRecoveryPassword,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useRecoveryPass = () => {
  const query = useMutation({
    mutationKey: ['useRecoveryPass'],
    mutationFn: restablecerPass,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useValidarTokenRecuperacion = () => {
  const query = useMutation({
    mutationKey: ['useValidarTokenRecuperacion'],
    mutationFn: validarTokenRecuperacion,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

// CA-17: {id_token, usuario_nombre?, usuario_apellido?} contra
// /apiV2/credencial/loginGoogle. Reemplaza al useLoginGoogle viejo
// (userinfo/v2/me + credencial/login genérico, ambos retirados — CA-21).
export const useLoginGoogle = () => {
  const query = useMutation({
    mutationKey: ['useLoginGoogle'],
    mutationFn: loginGoogle,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useLoginApple = () => {
  const query = useMutation({
    mutationKey: ['useLoginApple'],
    mutationFn: loginApple,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

// CA-19/CA-36: renueva el access token de sesión (single-flight, ver
// ApiCore._refreshSesion) — usado por ModalCredential tras completar el rut y
// por ProfileForm tras un cambio de rut confirmado por el backend. Devuelve
// `true`/`false`, nunca lanza (ApiCore ya maneja el fallo internamente con
// _forzarLogoutSesion).
export const useRefrescarSesion = () => {
  const query = useMutation({
    mutationKey: ['useRefrescarSesion'],
    mutationFn: refrescarSesion,
  });

  return query;
};

export const useUpdateCredencial = () => {
  const query = useMutation({
    mutationKey: ['useUpdateCredencial'],
    mutationFn: UpdateCredencial,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useGetOldPassword = () => {
  const query = useMutation({
    mutationKey: ['useGetOldPassword'],
    mutationFn: getOldPasswordByUserId,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};


export const useUpdatePassword = () => {

  return useMutation({
    mutationKey: ['updatePassword'],
    mutationFn: async (data) => { // Asegúrate de que esta función sea `async` si `updatePassword` devuelve una promesa
      return updatePassword(data); // Asegúrate de que `updatePassword` sea llamado aquí
    },
    onSuccess: (data) => {
      toast.success(data.message || 'Contraseña actualizada con éxito!');
     
    },
    onError: (error) => {
      const errorMessage = error instanceof Error ? error.message : 'Error desconocido al actualizar la contraseña.';
      toast.error(`Error: ${errorMessage}`);
      console.error('Error en la mutación:', error);
    },
    onSettled: () => {
      console.log('Mutación finalizada.');
    }
  });
};